module.exports = __webpack_public_path__ + "img/Wp_2077.4bffc0d4.png";